var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prd-empty has-text-centered"},[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-large"}}),_c('h3',{staticClass:"title is-6"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"has-text-grey"},[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }